import { NgModule } from '@angular/core';
import { RouterModule, RouterLink } from '@angular/router';

@NgModule({
  imports: [RouterModule.forRoot([])],
  exports: [RouterModule],
  providers: [RouterLink]
})
export class AppRouting {}
